const bareWebsite = window.location.hostname.split('.')[window.location.hostname.split('.').length - 2] || 'dentolize'

// Allow overriding API URL via environment variable (useful for local production builds)
const useLocalApi =
  process.env.REACT_APP_USE_LOCAL_API === 'true' ||
  (process.env.NODE_ENV !== 'production' && window.location.host.includes('localhost'))

export const BACKEND_URL = useLocalApi
  ? 'http://localhost:4000'
  : process.env.NODE_ENV === 'production'
  ? `https://qapi.${bareWebsite}.com`
  : window.location.host.includes('localhost')
  ? 'http://localhost:4000'
  : 'http://mdi.local:4000'

export const WS_BACKEND_URL = useLocalApi
  ? 'ws://localhost:4000/graphql'
  : process.env.NODE_ENV === 'production'
  ? `wss://qapi.${bareWebsite}.com/graphql`
  : window.location.host.includes('localhost')
  ? 'ws://localhost:4000/graphql'
  : 'ws://mdi.local:4000/graphql'

export const WEBSITE_HOME =
  process.env.NODE_ENV === 'production'
    ? `https://${bareWebsite}.com`
    : window.location.host.includes('localhost')
    ? 'http://localhost:3000'
    : 'http://mdi.local:3000'

export const DASHBOARD_HOME =
  process.env.NODE_ENV === 'production'
    ? `https://qa.${bareWebsite}.com`
    : window.location.host.includes('localhost')
    ? 'http://localhost:3000'
    : 'http://mdi.local:3000'

export const isMedicolize = bareWebsite.includes('medicolize')
export const mainTwoToneColor = isMedicolize ? '#6000ba' : '#0077b9'
export const qrCodeColor = isMedicolize ? '#2f005c' : '#00335b'

export const WEBSITE_NAME = bareWebsite.charAt(0).toUpperCase() + bareWebsite.slice(1)
export const ADMIN_LINK = 'ZROYKuKEVCvQykPlS4kP'
export const REFERRAL_LINK = 'NG6W5R0MQ1hybSv9Sfi'
export const maxTableRows = 50
export const minTableRows = 5
export const maxGroupedTableRows = 1000
export const mapboxAPIKey = 'pk.eyJ1IjoibWRhd291ZCIsImEiOiJja3R4a3VjNXAydXF4MnZwbjdlZ3J0N3AzIn0.3ezmZ6H7q5e9zkITlGz7kA'
export const NEW_UPDATE_VERSION = '55'
export const NEW_UPDATE_TEXT = false
export const NEW_UPDATE_VIDEO = 'https://youtu.be/v98ZyuZvPVI'
export const maxSMSCount = 5
export const maxArabicCharacters = 67
export const maxEnglishCharacters = 153
export const GA_MEASUREMENT_ID = 'G-T6H9L6B85S'

export const DATABASE_ICONS_URL = 'https://assets.dentolize.com/000Dentolize'

export const MAIN_COMPANY_ID = '54176b70-1b7c-455c-b5a6-84863dbe4d3e'
export const DISABLE_AUTO_HIDE_SIDEBAR = 'disableAutoHideSidebar'
